export default {
	//RutaApi: "https://api.cetolan.com.mx/api",
	RutaApi: "https://qasapi.cetolan.com.mx/api",
	//RutaApi: "https://localhost:44362/api",
	RutaAdjuntos: "/Uploads/",
	RutaPDF: "/PDF/",
	RutaUploadImagenes: "/Uploads/images/"
};
